import { useSession } from '../store/session';

const STEPS = [3, 4, 6, 8, 10, 12, 15];

export default function DurationPicker() {
  const d = useSession(s => s.durationSec);
  const setD = useSession(s => s.setDuration);
  return (
    <select className="chip" value={d} onChange={e => setD(parseInt(e.target.value, 10))}>
      {STEPS.map(s => <option key={s} value={s}>{s}s</option>)}
    </select>
  );
}
